module.exports = __webpack_public_path__ + "static/media/ActivateFlexiCard.9183ab44.png";